import { render, staticRenderFns } from "./ClickSimulatorSitecore.vue?vue&type=template&id=6058bcce"
import script from "./ClickSimulatorSitecore.vue?vue&type=script&lang=js"
export * from "./ClickSimulatorSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports